import React, { useState } from 'react'
import { Accordion } from 'react-bootstrap'
import Icon, { chevronDown } from '../../../../ui/Icon'
import classNames from 'classnames'

const AccordionList = ({ 
    list, 
    baseClassName = 'accordion-list-card',
    titleKey = 'title',
    contentKey = 'content'
}) => {
    const [activeKey, setActiveKey] = useState('');

    const handleClick = key => {
        activeKey === key ? setActiveKey('') : setActiveKey(key)
    }

    return (
        <div className="accordion-list">
            <Accordion activeKey={activeKey} defaultActiveKey="0">
                    {list.map((qa, idx) => {
                        return (
                            <div className={baseClassName}>
                                <Accordion.Toggle as="div" onClick={() => handleClick(idx)} eventKey={idx}>
                                    <div className={classNames(`${baseClassName}--toggle`, {open: activeKey === idx})}>
                                        <div>{qa[titleKey]}</div>
                                        <div><Icon svg={chevronDown} className="primary" /></div>
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={idx}>
                                    <div className={`${baseClassName}--body`}>
                                        {qa[contentKey].map(paragraph => <p>{paragraph}</p>)}
                                    </div>
                                </Accordion.Collapse>
                            </div>
                        )
                    })}
                </Accordion>
        </div>
    )
}

export default AccordionList
